import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { KbCustomImageZoomComponent } from './kb-custom-image-zoom/kb-custom-image-zoom.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [KbCustomImageZoomComponent],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    MediaModule,
    OutletModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule, 
    NgxPanZoomModule,
    MatIconModule,
      
  ],
  exports: [  
    KbCustomImageZoomComponent
  ],
})
export class KbCustomImageZoomModule { }
